"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyApiContract = void 0;
const core_1 = require("@ts-rest/core");
const candidates_1 = require("./candidates");
const jobs_1 = require("./jobs");
const organization_1 = require("./organization");
const talent_pools_1 = require("./talent-pools");
const templates_1 = require("./templates");
const c = (0, core_1.initContract)();
exports.CompanyApiContract = c.router({
    candidates: candidates_1.CandidatesContract,
    jobs: jobs_1.JobsContract,
    organization: organization_1.OrganizationContract,
    talentPools: talent_pools_1.TalentPoolsContract,
    templates: templates_1.TemplatesContract,
}, { pathPrefix: '/api/company' });
__exportStar(require("./candidates"), exports);
__exportStar(require("./jobs"), exports);
__exportStar(require("./organization"), exports);
__exportStar(require("./talent-pools"), exports);
__exportStar(require("./templates"), exports);
